export interface IDashboard {
	name: string;
	grid: IGridItem[];
	id: string;
	isDefault: boolean;
	isEnabled: boolean;
}

export interface IGridItem {
	idChart: string;
}

export interface ISharing {
	sharingTo: ISharingTo[],
	isSharingToCustomer: boolean;
	isSharingToCompany: boolean;
	isSharingToSelected: boolean;
}

export interface ISharingTo {
	id: string,
	targetName: string;
	idTarget: string;
	targetType: TargetType;
}

export enum TargetType {
	Company = 'Company',
	Customer = 'Customer',
	Group = 'Group',
	User = 'User'
}

export interface ISharingDashboardTo extends ISharingTo {
	idDashboard: string;
}
